<template>
  <div class="container">
    <div class="row align-items-sm-center justify-content-between">
      <div class="slopePage__title">
        <b>Material calculation</b>
      </div>
      <div class="toggler__box unprint" v-if="count > 1">
        <span class="showMore__text">
          Show quantity and volume in similar areas ({{ this.count }})
        </span>
        <div class="fixtureCalculation__toggle">
          <div class="wrapper">
            <span class="checkbox-toggler">
              <span class="checkbox-track"></span>
              <input type="checkbox"
                     v-model="isShowMore"
                     @click="isShowMore = !isShowMore">
                <span class="toggler"></span>
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="row computation">
      <div class="computation__head">
        <div class="computation__head-title">Group</div>
        <div class="computation__head-title">Material</div>
        <div class="computation__head-title computation__head-title--count">
          <!--:class="{'computation__head-title&#45;&#45;pl24':
             isShowMore === false || count <= 1}"-->
          <span>Number of panels</span>
          <span v-if="isShowMore && count > 1" class="computation__head-title--additional">
            {{ this.count }} areas
          </span>
        </div>
        <div class="computation__head-title computation__head-title--volume"
             >
          <!--:class="{'computation__head-title&#45;&#45;pl40': isShowMore}"-->
          <span>Volume</span>
          <span v-if="isShowMore && count > 1" class="computation__head-title--additional">
            {{ this.count }} areas
          </span>
        </div>
        <div class="computation__head-title unprint">Drawing</div>
      </div>
      <div class="computation__body">
        <div v-for="item in computation" class="computation__item" :key="item.id">
          <div class="computation__item-img">
            <img :src="allMaterials[allMaterials.findIndex
                 (p => p.id === slopeFromState.material)].src"
                 :alt="allMaterials[allMaterials.findIndex
                 (p => p.id === slopeFromState.material)].name">
          </div>
          <div class="computation__item-material">
            <div class="name">{{ allMaterials[allMaterials.findIndex
              (p => p.id === slopeFromState.material)].name }}
            </div>
            <div class="angle">
              <img src="@/assets/img/angle.svg" alt="angle">
              <b>{{ allMaterials[allMaterials.findIndex
                (p => p.id === slopeFromState.material)].angle }}%</b>
            </div>
          </div>
          <div class="computation__item-plate">
            <div class="size">
              {{ slopeFromState.materialSize.width }}х{{ slopeFromState.materialSize.height }} mm
            </div>
            <div class="plate"><b><span>Panel</span> {{ item.plateType }}</b></div>
            <div class="info" v-if="item.hasOwnProperty('plateInfo')">{{ item.plateInfo }}</div>
          </div>
          <div class="computation__item-count">
            <!--:class="{'computation__item-count&#45;&#45;pl40': isShowMore === false ||
            count <= 1, 'computation__item-count&#45;&#45;plMob': isShowMore !== false ||
            count > 1}"-->
            <span>{{ item.count }} pc.</span>
            <span class="computation__item-count--additional"
                  v-if="isShowMore && count > 1">
              {{ item.count * count }} pc.
            </span>
          </div>
          <div class="computation__item-volume computation__item-volume--plMob">
            <!--:class="{'computation__item-volume&#45;&#45;pl40,
            computation__item-volume&#45;&#45;plMobile' : isShowMore}"-->
            <span>{{ item.volume }} m³</span>
            <span class="computation__item-volume--additional"
                  v-if="isShowMore && count > 1">
              {{ (item.volume * count).toFixed(3) }} m³
            </span>
          </div>
          <div class="computation__item-eye unprint">
           <v-popover
            offset="10"
            placement="left"
            trigger="hover">
            <svg width="36" height="36" viewBox="0 0 36 36"
                 fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect width="36" height="36" rx="4" fill="white" class="overlay"></rect>
              <path d="M18 20.3333C19.3255 20.3333 20.4 19.2886 20.4 18C20.4 16.7114
              19.3255 15.6667 18 15.6667C16.6745 15.6667 15.6 16.7114 15.6 18C15.6 19.2886 16.6745
                       20.3333 18 20.3333Z" fill="#C9C9C9" class="eye-main"></path>
              <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M6 18C6 16.0105 11.36 11 18 11C24.64 11 30 16.0841 30
                    18C30 19.9895 24.64 25 18 25C11.36 25 6 19.9895 6 18ZM23.28
                    18C23.28 20.8351 20.9161 23.1333 18 23.1333C15.0839 23.1333
                    12.72 20.8351 12.72 18C12.72 15.1649 15.0839 12.8667 18 12.8667C20.9161
                    12.8667 23.28 15.1649 23.28 18Z" fill="#C9C9C9" class="eye-main"></path>
            </svg>
            <div slot="popover" class="eye-popover">
               <img :src="item.src" alt="" class="eye-popover__img">
            </div>
          </v-popover>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    count: Number,
  },
  data() {
    return {
      isShowMore: true,
    };
  },
  components: {
  },
  methods: {
  },
  watch: {
  },
  mounted() {
  },
  computed: {
    slopeFromState() {
      return this.$store.getters.getSlope(this.slopeId);
    },
    slopeId() {
      return (this.$route.params.id) ? this.$route.params.id : 0;
    },
    allSlopes() {
      return this.$store.getters.allSlopes;
    },
    allMaterials() {
      return this.$store.getters.allMaterials;
    },
    result() {
      return this.$store.getters.getResult;
    },
    computation() {
      return this.result.sections[this.$route.params.id].computation;
    },
  },
};

</script>

<style lang="sass" scoped>
.detailsPage
  .slopePage
    &__title
      +media((font-size: (320: rem(18), 768: rem(24))))
      +media((line-height: (320: rem(26), 768: rem(29))))
      +media((padding-top: (320: rem(43), 675: rem(23), 736: rem(36))))
      +media((padding-bottom: (320: rem(23), 768: rem(36))))
  .computation
    border-radius: rem(4) rem(4) 0 0
    color: $black
    &__head
      background: #F6F6F6
      display: grid
      // grid-template-columns: 4fr 4fr 4fr 4fr 5fr 3fr
      width: 100%
      +media((grid-template-columns: (320: 2fr 1fr 1fr, 600: 2fr 1fr 1fr 1fr,
      768: 1fr 1fr 1.5fr 1fr 1fr 1fr, 960: 4fr 4fr 1fr 5fr 3fr 3fr 1fr 3fr)))
      +media((padding: (320: 0 rem(24), 768: 0)))
      &-title
        min-height: rem(60)
        display: flex
        flex-direction: row
        align-items: center
        @extend .common__title-result
        text-align: left
        &--count, &--volume
          +media((justify-content: (320: flex-end, 960: flex-start)))
        &:first-of-type
          grid-column-start: 2
          +media((display: (320: none, 768: flex)))
        &:nth-child(2)
          // +media((padding-left: (320: 0, 768: rem(20), 992: rem(24))))
          // +media((min-width: (320: rem(150), 768: auto)))
        &:nth-child(2)
          +media((grid-column-start: (320: 1, 768: 3, 960: 4)))
        &:last-of-type
          +media((grid-column-start: (768: 6, 960: 8)))
          +media((display: (320: none, 600: flex)))
          justify-content: center
        span
          // min-width: rem(80)
          +media((min-width: (320: unset, 960: rem(80))))
        &--additional
          color: #999999
          min-width: rem(80)
          text-align: center
          +media((display: (320: none, 960: block)))
        sup
          display: block
          margin-top: rem(-5)
        &--pl24
          +media((padding-left: (320: 0, 768: rem(20), 992: rem(24))))
        &--pl40
          +media((padding-left: (320: 0, 768: rem(20), 992: rem(40))))
        &--pl70
          +media((padding-left: (768: rem(40), 992: rem(70))))
    &__body
      width: 100%
      display: grid
      margin-top: rem(1)
      grid-template-columns: 1fr
      grid-template-rows: 1fr
      grid-row-gap: rem(1)
    &__item
      background: #fff
      +media((grid-template-columns: (768: 1fr 1fr 1.5fr 1fr 1fr 1fr, 960: 4fr 4fr 1fr 5fr 3fr 3fr 1fr 3fr)))
      width: 100%
      font-style: normal
      font-weight: 500
      font-size: rem(14)
      line-height: rem(17)
      grid-row-gap: rem(1)
      min-height: rem(68)
      +media((display: (320: flex, 768: grid)))
      +media((height: (320: rem(96), 768: auto)))
      +media((display: (320: flex, 768: grid)))
      +media((padding: (320: 0 rem(24), 768: 0)))
      justify-content: space-between
      +media((justify-content: (320: space-between, 600: flex-start)))
      flex-direction: row
      flex-wrap: wrap
      +media((padding: (320: 0 rem(24), 768: 0)))
      // +media((padding-bottom: (320: rem(12), 768: 0)))
      +media((height: (320: rem(96), 768: auto)))
      position: relative
      &:after
        content: ""
        position: absolute
        left: rem(24)
        height: rem(1)
        width: calc(100% - 48px)
        background: #ECECEC
        top: 50%
        transform: translateY(-50%)
        +media((display: (320: block, 768:none)))
      &-material, &-plate, &-count, &-volume
        text-align: left
        display: flex
        flex-direction: column
        justify-content: center
      &-material, &-count, &-plate, &-volume, &-eye
        +media((height: (320: rem(48), 768: auto)))
      &-count, &-volume
        display: flex
        flex-direction: row
        align-items: center
        justify-content: flex-start
        span
          // min-width: rem(80)
          +media((min-width: (320: unset, 768: rem(80))))
        &--additional
          color: #999999
          +media((text-align: (320: right, 960: center)))
      &-material
        +media((order: (320: 1, 768: unset)))
        display: flex
        +media((flex-direction: (320: row, 768: column)))
        +media((align-items: (320: center, 768: flex-start)))
        +media((justify-content: (320: flex-start, 768: center)))
        +media((max-width: (320: rem(210), 360: 80%, 600: unset)))
        +media((min-width: (600: 87%, 768: unset)))
        position: relative
        // &:after
          content: ""
          position: absolute
          left: rem(24)
          bottom: rem(5)
          height: rem(1)
          width: calc(100% - 24px)
          background: #ECECEC
          +media((display: (320: block, 768:none)))
        .angle
          display: flex
          flex-direction: row
          align-items: center
          img
            margin-right: rem(6)
            line-height: 0
      &-plate, &-count, &-eye, &-volume
        &--pl40
          +media((padding-left: (320: 0, 768: rem(20), 992: rem(40))))
        &--pl24
          +media((padding-left: (320: 0, 768: rem(20), 992: rem(24))))
      &-count
        // +media((padding-right: (320: rem(40), 768: 0)))
        +media((flex-direction: (320: column, 960: row)))
        +media((justify-content: (320: center, 960: flex-start)))
        &--plMob
          // +media((padding-left: (320: rem(24), 768: 0)))
          +media((flex-direction: (320: column, 960: row)))
          +media((justify-content: (320: center, 960: flex-start)))
      &-volume
        &--plMob
          +media((flex-direction: (320: column, 960: row)))
          +media((justify-content: (320: center, 960: flex-start)))
        &--plMobile
          +media((padding-left: (320: 0, 992: rem(40))))
      &-count
        +media((order: (320: 4, 768: unset)))
        +media((width: (320: 25%, 600: 20%, 768: auto)))
        +media((text-align: (320: right, 960: left)))
      &-volume
        +media((order: (320: 5, 768: unset)))
        +media((width: (320: 25%, 600: 20%, 768: auto)))
        +media((text-align: (320: right, 960: left)))
      &-volume, &-count
        +media((align-items: (320: flex-end, 960: center)))
      &-plate
        display: flex
        +media((order: (320: 3, 768: unset)))
        +media((flex-direction: (320: row-reverse, 768: column)))
        +media((align-items: (320: center, 768: flex-start)))
        +media((width: (320: 50%, 600: 40%, 768: auto)))
        +media((justify-content: (320: flex-end, 768: center)))
        +media((grid-column-start: (768: 3, 960: 4)))
        .plate
          +media((padding-right: (320: rem(15), 768: 0)))
        span
          +media((display: (320: none, 400: inline-block)))
        .info
          +media((display: (320: none, 768: block)))
      &-img
        display: flex
        flex-direction: row
        justify-content: flex-start
        align-items: center
        padding-left: rem(14)
        +media((display: (320: none, 768: flex)))
        img
          max-width: rem(92)
      &-eye
        // +media((padding-left: (320: 0, 768: rem(40))))
        display: flex
        flex-direction: row
        align-items: center
        position: relative
        justify-content: center
        +media((grid-column-start: (768: 6, 960: 8)))
        +media((order: (320: 2, 768: unset)))
        // &:after
          content: ""
          position: absolute
          left: 0
          bottom: rem(5)
          height: rem(1)
          width: calc(100%)
          background: #ECECEC
          +media((display: (320: block, 768:none)))
        svg
          cursor: pointer
          &:hover
            .overlay
              fill: $red
            .eye-main
              fill: #fff
  .toggler__box
    display: flex
    flex-direction: row
    align-items: center
    +media((padding-right: (320: rem(27), 768: rem(3))))
    +media((padding-bottom: (320: rem(28), 675: rem(0))))
    .showMore
      &__text
        font-style: normal
        font-weight: 500
        padding-right: rem(20)
        text-align: left
        +media((padding-left: (320: rem(24), 768: 0)))
        +media((font-size: (320: rem(12), 992: rem(14))))
        +media((line-height: (320: rem(20), 992: rem(22))))
    .checkbox-toggler
      .checkbox-track
        box-shadow: inset 0 rem(2) rem(4) rgba(153, 153, 153, 0.5)
.eye-popover
  padding: rem(50) rem(25)
  &__img
    max-width: rem(225)
</style>
